import { Edit, Trash } from '@styled-icons/boxicons-solid'
import { deleteRequest, getRequest } from '../../../services/base'
import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import Pagination from '../../common/Pagination'
import Tooltip from '../../common/tooltip'
import NoRecordsFound from '../../common/NoRecordsFound'
import { createSearchParams, useParams } from 'react-router-dom'
import InputText from '../../common/InputText'
import Button from '../../common/Button'
import { encrypt } from '../../../utils/encryption'
import UnMappedSubSystem from './unmapped_sub_system'
import { getSessionStorageData } from '../../../utils/SessionStorage'
import ExportMissingConnectors from './export_missing_connectors'

const FunctionalDiagramRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-4/12 pl-10 items-center table_text">
          <Tooltip
            position={'top'}
            message={`${props.sub_system_id}/${props.name}`}
          >
            <div className="font-bold">{props.sub_system_id}</div>
            <div className="text-xs">{props.name}</div>
          </Tooltip>
        </div>
        <div className="flex w-4/12 pl-6 items-center table_text">
          <Tooltip
            position={'top'}
            message={`${props.system_data.system_id}/${props.system_data.name}`}
          >
            <div className="font-bold">{props.system_data.system_id}</div>
            <div className="text-xs">{props.system_data.name}</div>
          </Tooltip>
        </div>

        <div className="flex w-4/12 pl-6 justify-end ">
          <div>
            <span
              onClick={() => {
                props.onEdit()
              }}
              className="cursor-pointer p-2"
            >
              <Edit size="2rem" color="#0189E9" />
            </span>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <Trash size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

const FunctionalDiagram = (props) => {
  const [state, dispatch] = useContext(NavContext)
  const { vehicle } = useParams()
  const [subFunctionalDiagramListData, setFunctionalDiagramListData] = useState(
    []
  )
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [showModal, setShowModal] = useState(false)
  const [selectedFunctionalDiagram, setFunctionalDiagramSystem] = useState({})
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`
  const currentUrl = useRef(
    `/api/sub_system/?search=${searchValue}&is_connector_search=true&make=${vehicle}`
  )

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: vehicle,
        sub_header: 'Functional Diagram',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })

    getFunctionalDiagramList(null)
  }, [])

  const getFunctionalDiagramList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Functional Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(currentUrl.current)
    setFunctionalDiagramListData(response.results)
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const onDelete = async (functional_diagram) => {
    if (
      window.confirm(
        `Are you sure want to delete selected functional diagram`
      ) === true
    ) {
      let res = await deleteRequest(
        `/api/sub_system/functional-diagram/delete/${functional_diagram.id}/`
      )
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'Functional Diagram Deleted Successfully!',
        },
      })
      setTimeout(() => {
        getFunctionalDiagramList('')
      }, 100)
    }
  }

  const onEdit = (functional_diagram) => {
    let enc = encrypt(String(functional_diagram.id))
    window.location.href = `/vehicles/${vehicle}/functional-diagram/${enc}`
  }

  return (
    <div className="w-full">
      <div className="flex items-center w-full justify-between content-center">
        <form
          acceptCharset="UTF-8"
          onSubmit={(e) => {
            e.preventDefault()
            currentUrl.current = `/api/sub_system/?search=${searchValue}&is_connector_search=true&make=${vehicle}`
            getFunctionalDiagramList()
          }}
          className="flex items-center w-1/2"
        >
          <div
            className={`flex space-x-5 justify-between content-center items-center w-full`}
          >
            <div className="flex items-center w-full">
              <InputText
                name="search_value"
                placeholder={`Search Functional Diagram`}
                className={`w-100`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
            </div>
            <Button
              className={`cursor-pointer btn my-4 justify-end`}
              text={`Search`}
              onClick={() => {}}
            />
          </div>
        </form>
        <div className="flex w-1/2 justify-end content-center gap-1 items-center">
          <ExportMissingConnectors />
          <UnMappedSubSystem />
        </div>
      </div>

      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-4/12 pl-10 items-center">Sub System</div>
          <div className="flex w-4/12 pl-6 items-center">System</div>
          <div className="w-4/12 pl-6"></div>
        </div>
      </div>
      {subFunctionalDiagramListData?.map((functional_diagram, index) => {
        return (
          <FunctionalDiagramRow
            {...functional_diagram}
            key={`functional_diagram-${index}`}
            onDelete={() => {
              onDelete(functional_diagram)
            }}
            onEdit={() => {
              onEdit(functional_diagram)
            }}
          />
        )
      })}

      {subFunctionalDiagramListData?.length < 1 && (
        <NoRecordsFound
          caption={'Functional Diagram Not Found'}
          loading={false}
        />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            currentUrl.current = e
            getFunctionalDiagramList(e)
          }}
          onClickPrev={(e) => {
            currentUrl.current = e
            getFunctionalDiagramList(e)
          }}
        />
      </div>
    </div>
  )
}

export default FunctionalDiagram
